var _g, _g2, _g3, _circle, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkmain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1303,
    height: 592,
    viewBox: "0 0 1303 592",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_243_29)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.034 78.7593V587.124H756.51V353.293H622.774V263.582H456.226V183.838H319.997V78.7593H153.034ZM237.762 398.564C237.762 357.275 271.233 323.804 312.521 323.804C353.81 323.804 387.281 357.275 387.281 398.564V587.124H237.762V398.564ZM562.551 379.459C530.437 379.459 504.404 405.492 504.404 437.605V587.124H620.697V437.605C620.697 405.492 594.664 379.459 562.551 379.459Z",
    fill: "url(#paint0_linear_243_29)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_243_29)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M876.541 4C761.85 4 668.875 96.9749 668.875 211.665V587.125L720.791 587.125V212.761C720.791 126.743 790.523 57.0115 876.541 57.0115C962.558 57.0115 1032.29 126.743 1032.29 212.761V587.125L1084.21 587.125V211.665C1084.21 96.975 991.231 4 876.541 4Z",
    fill: "url(#paint1_linear_243_29)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_243_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M620.697 479.554V587.54H1157.3V171.793H1054.3V241.154H972.067V328.373H874.88V402.717H756.51V479.554H620.697Z",
    fill: "url(#paint2_linear_243_29)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1234.11,
    cy: 520.114,
    r: 68.1143,
    fill: "url(#paint3_linear_243_29)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_243_29)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8969 386.104L93.0341 395.242V587.125H0V395.242L9.13728 386.104L83.8969 386.104Z",
    fill: "url(#paint4_linear_243_29)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_243_29",
    x: 153.034,
    y: 74.7593,
    width: 667.476,
    height: 516.365,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 60
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_243_29"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_243_29",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_243_29",
    x: 668.875,
    y: 0,
    width: 469.331,
    height: 591.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 50
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_243_29"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_243_29",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_243_29",
    x: 620.697,
    y: 167.793,
    width: 600.607,
    height: 423.747,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 60
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_243_29"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_243_29",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_243_29",
    x: 0,
    y: 382.104,
    width: 157.034,
    height: 209.02,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 60
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_243_29"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_243_29",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_243_29",
    x1: 463.702,
    y1: 164.733,
    x2: 463.702,
    y2: 587.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9BF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#836B3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_243_29",
    x1: 876.541,
    y1: 83.517,
    x2: 876.541,
    y2: 467.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C4A40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_243_29",
    x1: 889.416,
    y1: 242.815,
    x2: 889.416,
    y2: 567.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74D0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#365D67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_243_29",
    x1: 1269.73,
    y1: 452.289,
    x2: 1234.11,
    y2: 588.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F97D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F1C0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_243_29",
    x1: 46.5171,
    y1: 386.104,
    x2: 46.5171,
    y2: 581.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C781FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613881"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkmain);
export default __webpack_public_path__ + "static/media/workmain.c0a5daeb85eac486216ce241211db359.svg";
export { ForwardRef as ReactComponent };